import { createSelector } from "reselect";
import get from "lodash/get";

const selectState = (state) => {
  return state.changeOrders;
};

export const getChangeOrders = createSelector(selectState, (changeOrders) => ({
  changeOrdersList: get(changeOrders, "changeOrdersList", []),
  totalCount: get(changeOrders, "totalCount", 0),
  changeOrdersLoading: get(changeOrders, "changeOrdersLoading", false),
}));

export const getChangeOrderData = createSelector(selectState, (changeOrders) =>
  get(changeOrders, "changeOrderData", null)
);

export const getChangeOrderStatuses = createSelector(
  selectState,
  (changeOrders) => get(changeOrders, "changeOrderStatuses", [])
);
